var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuSymposium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 70,
    viewBox: "0 0 75 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 31,
    r: 30,
    fill: "url(#paint0_linear_129_736)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 54.4503C15 55.657 15.4598 56.8142 16.2782 57.6674C17.0966 58.5206 18.2067 59 19.3641 59H64.6359C65.7933 59 66.9034 58.5206 67.7218 57.6674C68.5402 56.8142 69 55.657 69 54.4503V21H15V54.4503Z",
    fill: "#B4020E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3256 56.6667H18.8867C18.3064 56.6667 17.7318 56.5552 17.1956 56.3386C16.6595 56.122 16.1724 55.8045 15.762 55.4042C15.3517 55.004 15.0262 54.5288 14.8041 54.0059C14.5821 53.4829 14.4678 52.9224 14.4678 52.3564V12.6667C14.4678 11.9594 14.7558 11.2811 15.2685 10.781C15.7812 10.281 16.4766 10 17.2017 10H66.4127C67.1378 10 67.8332 10.281 68.3459 10.781C68.8586 11.2811 69.1467 11.9594 69.1467 12.6667V39.3333C69.1467 50.16 61.6283 54 49.3256 56.6667Z",
    fill: "#A7B5C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8629 56.6667H18.8867C18.3064 56.6667 17.7318 56.5552 17.1956 56.3386C16.6595 56.122 16.1724 55.8045 15.762 55.4042C15.3517 55.004 15.0262 54.5288 14.8041 54.0059C14.5821 53.4829 14.4678 52.9224 14.4678 52.3564V12.6667C14.4678 11.9594 14.7558 11.2811 15.2685 10.781C15.7812 10.281 16.4766 10 17.2017 10H66.4127C67.1378 10 67.8332 10.281 68.3459 10.781C68.8586 11.2811 69.1467 11.9594 69.1467 12.6667V39.3333C69.1467 42.6482 65.6149 42.4706 63.9036 42.19C63.6515 42.1473 63.3921 42.1913 63.1696 42.3146C62.9471 42.4378 62.7755 42.6327 62.6841 42.8657C61.6664 45.4539 57.9864 53.1457 49.2468 56.2534C48.4829 56.5258 47.6762 56.6656 46.8629 56.6667Z",
    fill: "url(#paint1_linear_129_736)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1608 23.7021C27.1799 23.7021 26.3604 24.4998 26.3604 25.4565V28.9651C26.3604 29.9219 27.1799 30.7212 28.1608 30.7212H31.7512C32.7321 30.7212 33.5499 29.9219 33.5499 28.9651V25.4565C33.5499 24.4998 32.7321 23.7021 31.7512 23.7021H28.1608Z",
    fill: "url(#paint2_linear_129_736)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9471 23.7021C37.9662 23.7021 37.1484 24.4998 37.1484 25.4565V28.9651C37.1484 29.9219 37.9662 30.7212 38.9471 30.7212H42.5463C43.5273 30.7212 44.345 29.9219 44.345 28.9651V25.4565C44.345 24.4998 43.5273 23.7021 42.5463 23.7021H38.9471Z",
    fill: "url(#paint3_linear_129_736)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.744 23.7021C48.7631 23.7021 47.9453 24.4998 47.9453 25.4565V28.9651C47.9453 29.9219 48.7631 30.7212 49.744 30.7212H53.3414C54.3224 30.7212 55.1419 29.9219 55.1419 28.9651V25.4565C55.1419 24.4998 54.3224 23.7021 53.3414 23.7021H49.744Z",
    fill: "url(#paint4_linear_129_736)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5301 23.7021C59.5492 23.7021 58.7314 24.4998 58.7314 25.4565V28.9651C58.7314 29.9219 59.5492 30.7212 60.5301 30.7212H64.1293C65.1103 30.7212 65.928 29.9219 65.928 28.9651V25.4565C65.928 24.4998 65.1103 23.7021 64.1293 23.7021H60.5301Z",
    fill: "url(#paint5_linear_129_736)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1608 34.2295C27.1799 34.2295 26.3604 35.0288 26.3604 35.9855V39.4942C26.3604 40.4509 27.1799 41.2485 28.1608 41.2485H31.7512C32.7321 41.2485 33.5499 40.4509 33.5499 39.4942V35.9855C33.5499 35.0288 32.7321 34.2295 31.7512 34.2295H28.1608Z",
    fill: "url(#paint6_linear_129_736)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9471 34.2295C37.9662 34.2295 37.1484 35.0288 37.1484 35.9855V39.4942C37.1484 40.4509 37.9662 41.2485 38.9471 41.2485H42.5463C43.5273 41.2485 44.345 40.4509 44.345 39.4942V35.9855C44.345 35.0288 43.5273 34.2295 42.5463 34.2295H38.9471Z",
    fill: "url(#paint7_linear_129_736)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5301 34.2295C59.5492 34.2295 58.7314 35.0288 58.7314 35.9855V39.4942C58.7314 40.4509 59.5492 41.2485 60.5301 41.2485H64.1293C65.1103 41.2485 65.928 40.4509 65.928 39.4942V35.9855C65.928 35.0288 65.1103 34.2295 64.1293 34.2295H60.5301Z",
    fill: "url(#paint8_linear_129_736)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1608 44.7588C27.1799 44.7588 26.3604 45.5495 26.3604 46.5063V50.0166C26.3604 50.9734 27.1799 51.771 28.1608 51.771H31.7512C32.7321 51.771 33.5499 50.9734 33.5499 50.0166V46.5063C33.5499 45.5495 32.7321 44.7588 31.7512 44.7588H28.1608Z",
    fill: "url(#paint9_linear_129_736)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9471 44.7588C37.9662 44.7588 37.1484 45.5495 37.1484 46.5063V50.0166C37.1484 50.9734 37.9662 51.771 38.9471 51.771H42.5463C43.5273 51.771 44.345 50.9734 44.345 50.0166V46.5063C44.345 45.5495 43.5273 44.7588 42.5463 44.7588H38.9471Z",
    fill: "url(#paint10_linear_129_736)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M49.744 44.7588C48.7631 44.7588 47.9453 45.5495 47.9453 46.5063V50.0166C47.9453 50.9734 48.7631 51.771 49.744 51.771H53.3414C54.3224 51.771 55.1419 50.9734 55.1419 50.0166V46.5063C55.1419 45.5495 54.3224 44.7588 53.3414 44.7588H49.744Z",
    fill: "url(#paint11_linear_129_736)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7496 34C48.7954 34 48 34.7972 48 35.7513V39.2504C48 40.2046 48.7954 41 49.7496 41H53.2487C54.2028 41 55 40.2046 55 39.2504V35.7513C55 34.7972 54.2028 34 53.2487 34H49.7496Z",
    fill: "url(#paint12_linear_129_736)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4127 10H17.2017C16.4766 10 15.7812 10.281 15.2685 10.781C14.7558 11.2811 14.4678 11.9594 14.4678 12.6667V20.6667H69.1467V12.6667C69.1467 11.9594 68.8586 11.2811 68.3459 10.781C67.8332 10.281 67.1378 10 66.4127 10Z",
    fill: "url(#paint13_linear_129_736)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2613 17.2213C61.7712 17.2213 62.9952 16.0274 62.9952 14.5547C62.9952 13.0819 61.7712 11.888 60.2613 11.888C58.7514 11.888 57.5273 13.0819 57.5273 14.5547C57.5273 16.0274 58.7514 17.2213 60.2613 17.2213Z",
    fill: "#7B151C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9397 8.53069V14.7267C61.9002 15.0775 61.7214 15.3993 61.4416 15.6231C61.1618 15.847 60.8033 15.955 60.4428 15.924H60.0806C59.7201 15.955 59.3616 15.847 59.0818 15.6231C58.802 15.3993 58.6232 15.0775 58.5837 14.7267V8.53069C58.6232 8.17993 58.8019 7.85819 59.0816 7.63439C59.3613 7.41059 59.7198 7.30253 60.0802 7.33336H60.4424C60.8029 7.30231 61.1616 7.41027 61.4415 7.63409C61.7213 7.85791 61.9002 8.17978 61.9397 8.53069Z",
    fill: "url(#paint14_linear_129_736)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9586 17.2213C49.4685 17.2213 50.6925 16.0274 50.6925 14.5547C50.6925 13.0819 49.4685 11.888 47.9586 11.888C46.4486 11.888 45.2246 13.0819 45.2246 14.5547C45.2246 16.0274 46.4486 17.2213 47.9586 17.2213Z",
    fill: "#7B151C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6369 8.53069V14.7267C49.5975 15.0775 49.4187 15.3993 49.1389 15.6231C48.8591 15.847 48.5005 15.955 48.1401 15.924H47.7778C47.4174 15.955 47.0588 15.847 46.779 15.6231C46.4993 15.3993 46.3205 15.0775 46.281 14.7267V8.53069C46.3205 8.17993 46.4992 7.85819 46.7789 7.63439C47.0586 7.41059 47.417 7.30253 47.7774 7.33336H48.1397C48.5002 7.30231 48.8589 7.41027 49.1387 7.63409C49.4186 7.85791 49.5975 8.17978 49.6369 8.53069Z",
    fill: "url(#paint15_linear_129_736)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6558 17.2213C37.1657 17.2213 38.3898 16.0274 38.3898 14.5547C38.3898 13.0819 37.1657 11.888 35.6558 11.888C34.1459 11.888 32.9219 13.0819 32.9219 14.5547C32.9219 16.0274 34.1459 17.2213 35.6558 17.2213Z",
    fill: "#7B151C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3342 8.53069V14.7267C37.2947 15.0775 37.1159 15.3993 36.8361 15.6231C36.5564 15.847 36.1978 15.955 35.8374 15.924H35.4751C35.1147 15.955 34.7561 15.847 34.4763 15.6231C34.1965 15.3993 34.0177 15.0775 33.9783 14.7267V8.53069C34.0177 8.17993 34.1965 7.85819 34.4762 7.63439C34.7559 7.41059 35.1143 7.30253 35.4747 7.33336H35.8369C36.1975 7.30231 36.5561 7.41027 36.836 7.63409C37.1159 7.85791 37.2947 8.17978 37.3342 8.53069Z",
    fill: "url(#paint16_linear_129_736)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3531 17.2213C24.863 17.2213 26.087 16.0274 26.087 14.5547C26.087 13.0819 24.863 11.888 23.3531 11.888C21.8432 11.888 20.6191 13.0819 20.6191 14.5547C20.6191 16.0274 21.8432 17.2213 23.3531 17.2213Z",
    fill: "#7B151C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0312 8.53069V14.7267C24.9917 15.0775 24.813 15.3993 24.5332 15.6231C24.2534 15.847 23.8948 15.955 23.5344 15.924H23.1721C22.8117 15.955 22.4531 15.847 22.1733 15.6231C21.8935 15.3993 21.7148 15.0775 21.6753 14.7267V8.53069C21.7148 8.17993 21.8935 7.85819 22.1732 7.63439C22.4529 7.41059 22.8113 7.30253 23.1717 7.33336H23.534C23.8945 7.30231 24.2531 7.41027 24.533 7.63409C24.8129 7.85791 24.9917 8.17978 25.0312 8.53069Z",
    fill: "url(#paint17_linear_129_736)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2298 58.7931C39.0224 57.5807 38.4501 56.4603 37.5894 55.5816C36.7286 54.7028 35.6204 54.1075 34.4125 53.875L25.8595 52.1953V50.6836C25.8595 50.5054 25.7887 50.3345 25.6627 50.2085C25.5367 50.0825 25.3658 50.0117 25.1876 50.0117H19.8126C19.6344 50.0117 19.4635 50.0825 19.3375 50.2085C19.2115 50.3345 19.1407 50.5054 19.1407 50.6836V52.1953L10.5878 53.875C9.37988 54.1075 8.27162 54.7028 7.41088 55.5816C6.55015 56.4603 5.97787 57.5807 5.77043 58.7931L4.35949 67.205C4.3438 67.3018 4.34948 67.4009 4.37614 67.4952C4.4028 67.5896 4.44979 67.677 4.51382 67.7512C4.57785 67.8255 4.65736 67.8849 4.74677 67.9251C4.83618 67.9654 4.93332 67.9856 5.03137 67.9844H39.9689C40.0659 67.9844 40.1618 67.9634 40.25 67.9228C40.3381 67.8822 40.4164 67.823 40.4795 67.7492C40.5433 67.6752 40.5901 67.5882 40.6168 67.4942C40.6435 67.4002 40.6494 67.3015 40.634 67.205L39.2298 58.7931Z",
    fill: "url(#paint18_linear_129_736)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7969 53.1561C17.7824 53.0672 17.7501 52.9822 17.7021 52.906C17.6541 52.8298 17.5912 52.7641 17.5172 52.7127C17.4433 52.6613 17.3597 52.6253 17.2716 52.6068C17.1834 52.5883 17.0925 52.5878 17.0041 52.6052L10.5877 53.875C9.38175 54.1119 8.27592 54.7087 7.41594 55.5866C6.55597 56.4646 5.98222 57.5826 5.77034 58.7931L4.3594 67.1983C4.34261 67.2956 4.34746 67.3954 4.37362 67.4906C4.39978 67.5858 4.4466 67.6741 4.51074 67.7491C4.57489 67.8242 4.65479 67.8842 4.74476 67.9248C4.83473 67.9655 4.93256 67.9858 5.03128 67.9844H19.4228C19.5209 67.9857 19.618 67.9654 19.7074 67.9252C19.7969 67.8849 19.8764 67.8255 19.9404 67.7513C20.0044 67.677 20.0514 67.5896 20.0781 67.4952C20.1047 67.4009 20.1104 67.3018 20.0947 67.205L17.7969 53.1561Z",
    fill: "url(#paint19_linear_129_736)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2296 58.7931C39.0178 57.5825 38.444 56.4646 37.584 55.5866C36.7241 54.7087 35.6182 54.1119 34.4123 53.875L27.9959 52.632C27.9075 52.6146 27.8166 52.6152 27.7284 52.6337C27.6403 52.6521 27.5567 52.6881 27.4828 52.7395C27.4088 52.7909 27.3459 52.8567 27.2979 52.9328C27.2498 53.009 27.2176 53.0941 27.2031 53.183L24.912 67.205C24.8963 67.3018 24.902 67.4009 24.9286 67.4952C24.9553 67.5896 25.0023 67.677 25.0663 67.7512C25.1303 67.8255 25.2098 67.8849 25.2993 67.9251C25.3887 67.9654 25.4858 67.9856 25.5839 67.9844H39.9687C40.0657 67.9844 40.1616 67.9634 40.2498 67.9228C40.3379 67.8822 40.4162 67.823 40.4793 67.7492C40.5421 67.6733 40.5883 67.585 40.615 67.4901C40.6416 67.3952 40.648 67.2958 40.6339 67.1983L39.2296 58.7931Z",
    fill: "url(#paint20_linear_129_736)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M27.949 52.5917C27.4115 52.4775 27.4518 52.7664 22.3792 56.2669L17.5954 52.7127C17.4826 52.6292 17.3476 52.5809 17.2075 52.5739C17.0673 52.5669 16.9282 52.6015 16.8076 52.6733C16.687 52.745 16.5904 52.8508 16.5297 52.9774C16.469 53.1039 16.4471 53.2456 16.4667 53.3845L18.7578 67.4334C18.7835 67.5924 18.8655 67.7369 18.9889 67.8405C19.1122 67.944 19.2686 67.9999 19.4296 67.9978H25.584C25.7451 67.9999 25.9015 67.944 26.0248 67.8405C26.1481 67.7369 26.2301 67.5924 26.2559 67.4334L28.547 53.3711C28.5586 53.1908 28.5044 53.0124 28.3944 52.869C28.2845 52.7257 28.1262 52.6272 27.949 52.5917Z",
    fill: "url(#paint21_linear_129_736)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2499 58.6722V56.408C33.2482 54.6676 32.556 52.999 31.3254 51.7683C30.0947 50.5377 28.4261 49.8455 26.6857 49.8438H18.3142C16.5738 49.8455 14.9052 50.5377 13.6745 51.7683C12.4439 52.999 11.7517 54.6676 11.7499 56.408V56.6297C11.0629 56.7658 10.4324 57.1049 9.94011 57.6032C9.44783 58.1015 9.11635 58.736 8.98854 59.4247L8.31666 62.9184C8.26294 63.2118 8.27499 63.5134 8.35193 63.8015C8.42887 64.0897 8.56879 64.3571 8.7616 64.5847C8.95442 64.8122 9.19532 64.9941 9.46693 65.1172C9.73854 65.2404 10.0341 65.3018 10.3323 65.2969H11.0781V63.9531H10.339C10.2396 63.9548 10.1411 63.9343 10.0506 63.8932C9.96002 63.8522 9.87972 63.7916 9.81545 63.7157C9.75117 63.6399 9.70453 63.5507 9.67889 63.4547C9.65324 63.3586 9.64922 63.2581 9.66713 63.1603L10.3054 59.6666C10.3941 59.1716 10.654 58.7235 11.0397 58.4008C11.4254 58.0781 11.9122 57.9013 12.4151 57.9013C12.918 57.9013 13.4048 58.0781 13.7905 58.4008C14.1762 58.7235 14.4361 59.1716 14.5248 59.6666L15.1631 63.1603C15.181 63.2581 15.177 63.3586 15.1513 63.4547C15.1257 63.5507 15.079 63.6399 15.0148 63.7157C14.9505 63.7916 14.8702 63.8522 14.7796 63.8932C14.6891 63.9343 14.5906 63.9548 14.4912 63.9531H13.7656V65.2969H14.5046C14.8028 65.3018 15.0984 65.2404 15.37 65.1172C15.6416 64.9941 15.8825 64.8122 16.0753 64.5847C16.2681 64.3571 16.408 64.0897 16.485 63.8015C16.5619 63.5134 16.574 63.2118 16.5203 62.9184L15.882 59.4247C15.7524 58.7324 15.4169 58.0952 14.9195 57.5966C14.422 57.0979 13.7857 56.761 13.0937 56.6297V56.408C13.0937 55.0234 13.6437 53.6956 14.6227 52.7165C15.6018 51.7375 16.9296 51.1875 18.3142 51.1875H26.6857C28.0703 51.1875 29.3981 51.7375 30.3772 52.7165C31.3562 53.6956 31.9062 55.0234 31.9062 56.408V58.6722C31.2728 58.8357 30.7209 59.2246 30.3538 59.766C29.9866 60.3074 29.8296 60.9641 29.912 61.613C29.9944 62.2619 30.3107 62.8585 30.8015 63.2909C31.2923 63.7233 31.9239 63.9619 32.5781 63.9619C33.2322 63.9619 33.8639 63.7233 34.3547 63.2909C34.8455 62.8585 35.1617 62.2619 35.2442 61.613C35.3266 60.9641 35.1695 60.3074 34.8024 59.766C34.4353 59.2246 33.8833 58.8357 33.2499 58.6722Z",
    fill: "url(#paint22_linear_129_736)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1094 37.75C14.2184 37.75 13.3639 38.1039 12.7339 38.7339C12.1039 39.3639 11.75 40.2184 11.75 41.1094C11.75 42.0003 12.1039 42.8548 12.7339 43.4848C13.3639 44.1148 14.2184 44.4688 15.1094 44.4688C15.2876 44.4688 15.4585 44.398 15.5845 44.272C15.7105 44.146 15.7812 43.9751 15.7812 43.7969V38.4219C15.7812 38.2437 15.7105 38.0728 15.5845 37.9468C15.4585 37.8208 15.2876 37.75 15.1094 37.75Z",
    fill: "url(#paint23_linear_129_736)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8906 37.75C29.7124 37.75 29.5415 37.8208 29.4155 37.9468C29.2895 38.0728 29.2188 38.2437 29.2188 38.4219V43.7969C29.2188 43.9751 29.2895 44.146 29.4155 44.272C29.5415 44.398 29.7124 44.4688 29.8906 44.4688C30.7816 44.4688 31.6361 44.1148 32.2661 43.4848C32.8961 42.8548 33.25 42.0003 33.25 41.1094C33.25 40.2184 32.8961 39.3639 32.2661 38.7339C31.6361 38.1039 30.7816 37.75 29.8906 37.75Z",
    fill: "url(#paint24_linear_129_736)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4709 52.3095L25.8595 52.1953V50.6836C25.8595 50.5054 25.7887 50.3345 25.6627 50.2085C25.5367 50.0825 25.3658 50.0117 25.1876 50.0117H19.8126C19.6344 50.0117 19.4635 50.0825 19.3375 50.2085C19.2115 50.3345 19.1407 50.5054 19.1407 50.6836V52.1953L18.5293 52.3095C19.7707 52.8968 21.1268 53.2014 22.5001 53.2014C23.8733 53.2014 25.2295 52.8968 26.4709 52.3095Z",
    fill: "#E57E70"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8906 34.6056L15.1094 34.3167C14.9302 34.3225 14.7588 34.3915 14.6256 34.5116C14.5622 34.5738 14.5116 34.648 14.477 34.7299C14.4424 34.8118 14.4244 34.8997 14.4241 34.9886V43.7969C14.4241 45.9352 15.2735 47.9859 16.7855 49.4979C18.2975 51.0099 20.3483 51.8594 22.4866 51.8594C24.6249 51.8594 26.6756 51.0099 28.1876 49.4979C29.6996 47.9859 30.5491 45.9352 30.5491 43.7969V35.2775C30.5491 35.1016 30.4802 34.9327 30.3571 34.8071C30.234 34.6815 30.0665 34.6091 29.8906 34.6056Z",
    fill: "url(#paint25_linear_129_736)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0395 31.2261C29.474 29.6875 27.1225 30.0167 26.1146 30.2586C25.6309 29.748 24.5828 29.0156 22.5 29.0156C19.5773 29.0156 14.6928 29.0156 13.1676 32.0727C11.7231 34.955 12.7376 39.0064 12.7846 39.1744C12.8067 39.265 12.8473 39.35 12.904 39.424C12.9607 39.498 13.0322 39.5595 13.1139 39.6044C13.5237 39.8194 13.8261 39.5372 14.4576 39.3692V39.7656C14.4576 39.9438 14.5284 40.1147 14.6544 40.2407C14.7804 40.3667 14.9513 40.4375 15.1295 40.4375C17.2167 40.4318 19.2975 40.2066 21.3376 39.7656C22.7285 39.4127 23.9982 38.6908 25.0128 37.6761C26.3565 39.8798 29.595 40.6256 29.7562 40.6592C29.8543 40.6804 29.956 40.6793 30.0536 40.6561C30.1513 40.6328 30.2425 40.588 30.3206 40.5248C30.7036 40.2158 30.5356 39.7723 30.5692 39.3491C31.1604 39.1139 31.745 39.1677 31.9129 38.6234C31.9398 38.4219 33.3037 33.497 31.0395 31.2261Z",
    fill: "url(#paint26_linear_129_736)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_129_736",
    x1: 0.00000102593,
    y1: -4.83333,
    x2: 37.5,
    y2: 61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_129_736",
    x1: 14.4678,
    y1: 33.3333,
    x2: 69.1467,
    y2: 33.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5109,
    stopColor: "#EFF0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#E8EAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    stopColor: "#DDDEDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9315,
    stopColor: "#CCCDCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_129_736",
    x1: 29.9551,
    y1: 23.7021,
    x2: 29.9551,
    y2: 30.7212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C0CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_129_736",
    x1: 40.7467,
    y1: 23.7021,
    x2: 40.7467,
    y2: 30.7212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C0CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_129_736",
    x1: 51.5436,
    y1: 23.7021,
    x2: 51.5436,
    y2: 30.7212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C0CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_129_736",
    x1: 62.3297,
    y1: 23.7021,
    x2: 62.3297,
    y2: 30.7212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C0CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_129_736",
    x1: 29.9551,
    y1: 34.2295,
    x2: 29.9551,
    y2: 41.2485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C0CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_129_736",
    x1: 40.7467,
    y1: 34.2295,
    x2: 40.7467,
    y2: 41.2485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C0CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_129_736",
    x1: 62.3297,
    y1: 34.2295,
    x2: 62.3297,
    y2: 41.2485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C0CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_129_736",
    x1: 29.9551,
    y1: 44.7588,
    x2: 29.9551,
    y2: 51.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C0CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_129_736",
    x1: 40.7467,
    y1: 44.7588,
    x2: 40.7467,
    y2: 51.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C0CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_129_736",
    x1: 51.5436,
    y1: 44.7588,
    x2: 51.5436,
    y2: 51.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C0CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_129_736",
    x1: 47.9994,
    y1: 37.5,
    x2: 54.9994,
    y2: 37.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6000D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4229,
    stopColor: "#E60011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7781,
    stopColor: "#A7000C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60011"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_129_736",
    x1: 41.8072,
    y1: 10,
    x2: 41.8072,
    y2: 20.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8010D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E90111"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_129_736",
    x1: 58.5835,
    y1: 11.6287,
    x2: 61.9394,
    y2: 11.6287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6000D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4229,
    stopColor: "#E60011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7781,
    stopColor: "#A7000C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60011"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_129_736",
    x1: 46.2807,
    y1: 11.6287,
    x2: 49.6366,
    y2: 11.6287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6000D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4229,
    stopColor: "#E60011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7781,
    stopColor: "#A7000C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60011"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_129_736",
    x1: 33.978,
    y1: 11.6287,
    x2: 37.3339,
    y2: 11.6287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6000D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4229,
    stopColor: "#E60011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7781,
    stopColor: "#A7000C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60011"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_129_736",
    x1: 21.675,
    y1: 11.6287,
    x2: 25.0309,
    y2: 11.6287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6000D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4229,
    stopColor: "#E60011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7781,
    stopColor: "#A7000C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60011"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_129_736",
    x1: 22.5001,
    y1: 50.005,
    x2: 22.5001,
    y2: 67.9844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B7A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7907F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_129_736",
    x1: 4.34961,
    y1: 60.2885,
    x2: 20.1034,
    y2: 60.2885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5109,
    stopColor: "#EFF0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#E8EAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    stopColor: "#DDDEDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9315,
    stopColor: "#CCCDCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_129_736",
    x1: 32.7729,
    y1: 52.5917,
    x2: 32.7729,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_129_736",
    x1: 22.5041,
    y1: 52.5723,
    x2: 22.5041,
    y2: 67.9979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.631043,
    stopColor: "#E90111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981672,
    stopColor: "#A8010D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_129_736",
    x1: 21.7945,
    y1: 65.2969,
    x2: 21.7945,
    y2: 49.8438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#606060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_129_736",
    x1: 13.7656,
    y1: 37.75,
    x2: 13.7656,
    y2: 44.4688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B7A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7907F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_129_736",
    x1: 31.2344,
    y1: 37.75,
    x2: 31.2344,
    y2: 44.4688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B7A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7907F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_129_736",
    x1: 22.5,
    y1: 34.3167,
    x2: 22.5,
    y2: 51.8594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B7A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7907F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_129_736",
    x1: 22.3843,
    y1: 40.6742,
    x2: 22.3843,
    y2: 29.0156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#606060"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSymposium);
export default __webpack_public_path__ + "static/media/menu-symposium.50a9201a1167976359d12ebdf89e0933.svg";
export { ForwardRef as ReactComponent };